import type { CheckoutPaymentOptionsV2 } from '@tectonics/prs/incoming-payment';

export const DIRECT_DEBIT_BANK_LIST_KEY = 'direct-debit_bank_list';

const MISSING_BANK_LIST_ERROR = 'Payment options: there is no `Direct Debit` bank list in available options list';

export interface DirectDebitBank {
  readonly name: string;
  readonly value: string;
  readonly logo_url?: string;
}

export type DirectDebitBankList = readonly DirectDebitBank[];

export function getSafeDirectDebitPaymentOption(paymentOptions: readonly unknown[] | CheckoutPaymentOptionsV2): DirectDebitBankList {
  if (Array.isArray(paymentOptions)) throw new Error(MISSING_BANK_LIST_ERROR);

  const bankList = (paymentOptions as Record<string, unknown>)[DIRECT_DEBIT_BANK_LIST_KEY];

  if (!isDirectDebitBankList(bankList)) throw new Error(MISSING_BANK_LIST_ERROR);

  return bankList;
}

function isDirectDebitBankList(bankList: unknown): bankList is DirectDebitBankList {
  return Array.isArray(bankList) && bankList.every(bank =>
    typeof bank === 'object' && bank !== null &&
    typeof bank.name === 'string' && typeof bank.value === 'string' &&
    (bank.logo_url === undefined || typeof bank.logo_url === 'string')
  );
}
